import { Box } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { ListProps } from "react-virtuoso";
import { useGroupedVirtualizedContext } from "./context";

export const VirtuosoList = forwardRef(function VirtuosoList(
  { children, ...props }: ListProps,
  ref?: Ref<HTMLDivElement>
) {
  const { slotProps } = useGroupedVirtualizedContext();

  return (
    <Box {...props} {...slotProps?.list} ref={ref}>
      {children}
    </Box>
  );
});
